import { useEffect, useState } from 'react';
import { ForgotPasswordProp } from '../resetForgottenPassword.type';
import { ENDPOINT_CONSTANTS } from 'constant';

export type NewPasswordPayload = {
  password: string;
  registerNumber: string;
};

const useResetPassword = (token: string | null) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const resetPassword = async (
    payload: ForgotPasswordProp,
    successCallback: () => void
  ) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}${ENDPOINT_CONSTANTS.RESET_FORGOT_PASSWORD}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      if (response.status === 400) {
        const responseData = await response.json();
        const message = responseData?.error
          ? responseData?.error
          : responseData.message
          ? responseData.message
          : 'Something went wrong';
        setErrorMessage(message);
      } else if (response.status !== 200) {
        setIsError(true);
      } else {
        successCallback();
      }
    } catch (error) {
      console.log(error, 'error');
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage(null);
      }, 3000);
    }
  }, [errorMessage]);

  return { resetPassword, isLoading, isError, errorMessage };
};

export default useResetPassword;
